import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { TranslationKeyEnum } from '../../types/constants';
import { BoltIcon } from '../icons';
import { usePetParentReportActions } from '../../hooks/usePetParentReports';

interface ComplianceWarningBannerProps {
  className?: string;
}

export const ComplianceWarningBanner: React.FC<ComplianceWarningBannerProps> = ({
  className = '',
}) => {
  const { t } = useTranslation();
  const { downloadOptinGuide } = usePetParentReportActions();

  const handleDownloadGuide = () => {
    downloadOptinGuide();
  };

  return (
    <div className={`relative rounded-[8px] border bg-[#FAF2F3] border-[#FAD2D8] ${className}`}>
      <div className="flex items-center gap-3 flex-1 p-8">
        <div>
          <BoltIcon height={30} width={20} fill="#8D1400" />
        </div>
        <p className="font-medium text-base text-black-600">
          <span className="font-bold text-black-800">
            {t(TranslationKeyEnum.ComplianceWarningTitle)}
          </span>{' '}
          {t(TranslationKeyEnum.ComplianceWarningDescription)}{' '}
          <button
            onClick={handleDownloadGuide}
            className="underline hover:opacity-80 transition-opacity inline font-bold text-black"
          >
            {t(TranslationKeyEnum.ComplianceWarningLinkText)}
          </button>
          .
        </p>
      </div>
    </div>
  );
};
